let countryCode: string | undefined

export async function locateCountry(): Promise<string | undefined> {
  if (countryCode) return countryCode
  const response = await fetch('https://ip2c.org/s')
  const data = await response.text()
  const [status, code] = data.split(';')
  if (status === '1') {
    countryCode = code
    return countryCode
  }
}
